/* RESPONSIBLE TEAM: team-knowledge-foundations */
import ApplicationAdapter from '../application';
import type TaskSuggestion from 'embercom/models/content-service/task-suggestion';

export default class TaskSuggestionAdapter extends ApplicationAdapter {
  pathForType(): string {
    return 'ai_insights/task_suggestions';
  }

  // Override buildURL to ensure we use the correct path
  buildURL(_modelName: any, _id?: string | number, _snapshot?: any, _requestType?: string): string {
    let baseUrl = '/ember/ai_insights/task_suggestions';
    if (_id) {
      return `${baseUrl}/${_id}`;
    }
    return baseUrl;
  }

  // Approve a task suggestion
  async approve(taskSuggestion: TaskSuggestion): Promise<TaskSuggestion> {
    let url = `${this.buildURL('task-suggestion', taskSuggestion.id)}/approve`;
    await this.ajax(url, 'POST');
    return taskSuggestion;
  }

  // Reject a task suggestion
  async reject(taskSuggestion: TaskSuggestion): Promise<TaskSuggestion> {
    let url = `${this.buildURL('task-suggestion', taskSuggestion.id)}/reject`;
    await this.ajax(url, 'POST');
    return taskSuggestion;
  }
}
